var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDankort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-153 -46 652 652",
    style: {
      enableBackground: "new -153 -46 652 652"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#E31F28;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.8,30.3c-135.2,0-245.1,109.9-245.1,244.9S-131.4,520.2,3.8,520.2h329.9c135,0,245.1-109.9,245.1-245.1 c0-135-109.9-245.1-245.1-245.1H3.8V30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.8,525.3H3.8c-137.8,0-250.1-112.1-250.1-250.1c0-137.8,112.1-249.9,250.1-249.9h329.9 c137.8,0,249.9,112.1,249.9,249.9C583.7,413.1,471.6,525.3,333.8,525.3 M3.8,30.3c-135.2,0-245.1,109.9-245.1,244.9 S-131.4,520.2,3.8,520.2h329.9c135,0,245.1-109.9,245.1-245.1c0-135-109.9-245.1-245.1-245.1H3.8V30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M391.4,260.3l109.7,130.6c22.8-32.8,36-72.6,36-115.6c0-45.2-14.8-87.1-40-120.9L391.4,260.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.4,143.2c81.9,0,143.7,20.9,150.1,89.9l86.2-89.9h171.8C451,99.4,395.7,71.6,333.8,71.6H3.8 c-61.9,0-117.5,27.8-154.7,71.6C-150.9,143.2,80.4,143.2,80.4,143.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-54.5,230.3l-29.3,80.4H34.3c34.8,0,45.5-14.5,53.3-42.3c7.8-27.6-11.7-38.1-35.5-38.1L-54.5,230.3 L-54.5,230.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M317.5,401.8l-91.2-115.2c-16.9,78.6-72.1,115.2-175.6,115.2h-206.3c37.3,46.9,94.9,76.9,159.4,76.9h329.9 c64.5,0,121.9-30.2,159.2-76.9H317.5z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDankort);
export default __webpack_public_path__ + "static/media/dankort.e6a3756d51856364cf04d6cdf2624935.svg";
export { ForwardRef as ReactComponent };